import { useTheme } from '@ui-kitten/components'

export type Colors = {
  primary: string
  secondary: string
  black: string
  white: string
  ghostWhite: string
  borderGrey: string
  lightGrey: string
  disabledGrey: string
  selectedLightBlue: string
  mediumGrey: string
  background: string
  red: string
  danger: string
  green: string
  blue: string
  yellow: string
  avocado: string
  purple: string
  lightBlue: string
  peach: string
  orange: string
  skin: string
  info: string
}

/**
 * Theme-aware replacement for the static `utils/colors.js` dictionary.
 *
 * Returns the same keys as the legacy `colors` object but resolves
 * semantic colors from the current Eva theme, so values adapt
 * automatically when the user switches between light and dark mode.
 *
 * Migration: replace `import colors from '../utils/colors'`
 *       with `const colors = useColors()`
 */
export function useColors(): Colors {
  const theme = useTheme()

  return {
    // Semantic colors mapped to Eva theme tokens (adapt to light/dark)
    primary: theme['color-primary-500'],
    secondary: theme['color-info-500'],
    black: theme['text-basic-color'],
    white: theme['background-basic-color-1'],
    ghostWhite: theme['background-basic-color-2'],
    borderGrey: theme['border-basic-color-3'],
    lightGrey: theme['background-basic-color-2'],
    disabledGrey: theme['text-disabled-color'],
    selectedLightBlue: theme['color-primary-transparent-100'],
    mediumGrey: theme['text-hint-color'],
    background: theme['background-basic-color-3'],
    info: theme['color-info-500'],

    // Static accent/brand colors (identical in both themes)
    red: '#fc5c65',
    danger: '#fc5c65',
    green: '#25D366',
    blue: '#8AC4FF',
    yellow: '#EADC90',
    avocado: '#ABDFC6',
    purple: '#D5BFEC',
    lightBlue: '#9CD5E3',
    peach: '#F7C5BC',
    orange: '#F5AF91',
    skin: '#E2BDC1',
  }
}
